<template lang="pug">
.right_box_main
    .card-box
        .listBox
            .listBox-item
                //- .mianbao 
                //-     el-breadcrumb(separator-class='el-icon-arrow-right')
                //-         el-breadcrumb-item(:to="{ path: '/' }") 首页
                //-         el-breadcrumb-item(:to="{ path: '/griddingindex' }") 网格工作
                //-         el-breadcrumb-item(:to="{ path: '/twoNetworkConvergence' }") 两网融合
                //-         el-breadcrumb-item 网格日志
 
                el-card 
                    .card_content
                        el-form(v-if="$store.state.info.orgLevel != 4" ,  :inline="true" :model="searchlist" class="demo-form-inline" size="mini")
                            el-form-item(label='组织机构:' , v-if="$store.state.info.orgLevel != 3" ,  )
                                el-cascader(ref='orgName',:props="cascaderProps" size='mini', v-model='searchlist2.orgId', :options='orgTree', :show-all-levels='false', placeholder='请选择所属网格', style='width:250px', clearable='',@change="cascaderChange" )
                                  
                            el-form-item(label='网格员:' ,  )
                                el-input(v-model='searchlist2.createName', placeholder='请输入')  
 
                            //- el-form-item(label='时间:' )
                            //-     el-date-picker(v-model="searchlist2.gridLogTime", type="daterange", value-format="yyyy-MM-dd",range-separator="至",start-placeholder="开始日期",end-placeholder="结束日期",style="width:350px")
 
                            el-form-item
                                el-button(type='primary', @click='searchlistdata2') 查询
                            el-form-item
                                el-button(type='info', @click='searchlistReset2') 重置

                        el-row.title-col(style='margin-bottom:10px;', type='flex', justify='space-between')
                            el-col
                                el-button(v-if="$store.state.info.orgLevel == 4" , type='primary', size='mini',  @click="showDialog('','add')") 新增 
                        el-row.page-list-box(:gutter='20',v-show="showListitem == 'detail'") 
                            // 网格员日志列表 
                            el-col.page-list-item.person(:span='8',v-for="item in tableData")
                                el-card(:body-style="{ padding: '0px' }" shadow="never")
                                    h2.title {{item.title}}
                                    div.main(v-html="item.handleMatter")
                                    div.main(v-html="item.residentVoice")
                                    div.main(v-html="item.todaySummary")
                                    div.bottom
                                        div.calue {{item.createName}}
                                        div.time {{item.createDate}}
                            el-button(v-if="$store.state.info.orgLevel !== 4" @click="listitemCliakbackPerson(tableData[0])",type='primary',size="mini",style="position:absolute;top: -61px;left: 462px;") 上一级
                            // 社区+网格列表 
                        el-row.page-list-box(:gutter='20',v-show="showListitem != 'detail'") 
                                el-col.page-list-item(:span='4',v-for="item in pageList") 
                                    el-card(:body-style="{ padding: '0px' }" shadow="never")
                                        
                                        div(@click="listitemCliak(item)")
                                            img.image(v-if='showListitem == "communityName"',src='@/assets/images/Gridding/shequ_icon.png')
                                            img.image(v-else-if='showListitem == "gridName"',src='@/assets/images/Gridding/wangge_icon.png')
                                            img.image(v-else,src='@/assets/images/Gridding/person_icon.png')

                                            div(style='padding: 14px;')
                                                span {{  item[showListitem] }}
                                el-button(@click="listitemCliakback(pageList[0])",type='primary',size="mini",style="position:absolute;top: -61px;left: 462px;") 上一级      
                                el-col(:span="24",v-if="pageList && pageList.length == 0") 暂无数据
                                
                        el-pagination(v-show="showListitem == 'detail'",@current-change='handleCurrentChange', :current-page='pageConfig.pageNo', :page-size='pageConfig.pageSize', layout='total, prev, pager, next, jumper', :total='pageConfig.total')
               
    //编辑form表单你
    editForm(v-bind="editDialog",:pagetype="pagetypes",@func="dialogReback")

</template>

<script>
import { gridLogApi, OrgTreelist, getGridUserList } from "@/api/http.js";
import { tabdata } from "@/mixins/tabledataMix.js";
import editForm from "./graddingLogChild/editform.vue";
import request from "../../../utils/request";

export default {
    name: "graddingLog",
    mixins: [tabdata],
    components: { editForm },

    computed: {},
    data() {
        return {
            showListitem: "communityName",
            cascaderProps: {
                value: "orgId",
                label: "label",
                children: "children",
                checkStrictly: true
            },
            cascaderData: [],
            pagetypes: 2,
            editDialog: {
                show: "",
                readonly: false,
                fatherdata: null,
                fatherid: null
            },
            liveStatusObj: {
                0: "待直播",
                1: "直播中",
                2: "已结束"
            },
            timeArr: [],
            liveTypesIdArr: [],
            searchlist2: {
                orgId: []
            },
            userOptions: [],
            orgTree: [],
            pageList: []
        };
    },
    filters: {},
    methods: {
        listitemCliakbackPerson(item){
            this.searchlist.communityId = item.communityId;
            this.searchlist.gridId = item.gridId;
            this.showListitem = "createName";   
            this.getpageList();         
        },
        listitemCliak(item) {
            console.log("item====", item);
            if (this.showListitem == "communityName") {
                this.searchlist.communityId = item.communityId;
                this.showListitem = "gridName";
            } else if (this.showListitem == "gridName") {
                this.searchlist.communityId = item.communityId;
                this.searchlist.gridId = item.gridId;
                this.showListitem = "createName";
            } else if (this.showListitem == "createName") {
                this.searchlist.communityId = item.communityId;
                this.searchlist.gridId = item.gridId;
                this.searchlist.createName = item.createName;
                this.showListitem = "detail";
            }

            this.getpageList();
        },

        listitemCliakback(item) {
            console.log("item====", item);
               if (this.showListitem == "createName") {
               this.searchlist.communityId = item.communityId;
                this.searchlist.gridId = item.gridId;
                this.showListitem = "gridName";
            } else if (this.showListitem == "gridName") {
                this.searchlist.communityId = item.communityId;
                this.showListitem = "communityName";
            } else if (this.showListitem == "communityName") {
              this.searchlist.communityId = item.communityId;
                this.showListitem = "gridName";
            }

            this.getpageList();
        },
        // 组织机构
        cascaderChange(val) {
            if (val && val.length) {
                if (val.length == 3) {
                    this.searchlist.communityId = val[1];
                    this.searchlist.gridId = val[2];
                } else if (val.length == 2) {
                    this.searchlist.communityId = val[1];
                    this.searchlist.gridId = "";
                }
            } else {
                this.searchlist.communityId = "";
                this.searchlist.gridId = "";
            }
        },
        //获取人员
        getUser(value) {
            this.userOptions = [];
            getGridUserList({
                orgId: this.searchlist2.orgId[
                    this.searchlist2.orgId.length - 1
                ],
                pageNo: 1,
                pageSize: 999
            }).then(res => {
                res.content.list.forEach(e => {
                    this.userOptions.push({
                        value: e.id,
                        label: e.name
                    });
                });
            });
        },

        async OrgTreelist() {
            let res = await OrgTreelist({ orgType: 1, orgLevel: 3 });
            // console.log(">>>>>>>>",res);
            if (!res.content) return;
            res.content[0].disabled = true;
            this.orgTree = res.content;
        },
        searchlistReset2() {
            this.searchlist2 = {};
            this.searchlist = {};
            if (this.$store.state.info.orgLevel == 4) {
                this.showListitem = "detail";
            } else if (this.$store.state.info.orgLevel == 3) {
                this.showListitem = "gridName";
                this.searchlist.gridId = this.$store.state.info.orgId;
                this.searchlist.communityId = this.$store.state.info.committeeCode;
            } else if (this.$store.state.info.orgLevel == 2) {
                this.showListitem = "communityName";
            }

            this.getpageList();
        },
        searchlistdata2() {
            if (this.searchlist2.createName) {
                this.showListitem = "detail";
                this.searchlist.communityId = "";
                this.searchlist.gridId = "";
                this.searchlist.createName = this.searchlist2.createName;
                this.initTableDataUrl(gridLogApi.getTableDataUrl);
                console.log(1);
                return;
            }

            if (this.$store.state.info.orgLevel == 4) {
                this.showListitem = "detail";
            } else if (this.$store.state.info.orgLevel == 3) {
                this.showListitem = "gridName";
                this.searchlist.gridId = this.$store.state.info.orgId;
                this.searchlist.communityId = this.$store.state.info.committeeCode;
            } else if (this.$store.state.info.orgLevel == 2) {
                this.showListitem = "communityName";
                let val = this.searchlist2.orgId || [];
                if (val.length) {
                    if (val.length == 3) {
                        this.searchlist.communityId = val[1];
                        this.searchlist.gridId = val[2];
                        this.showListitem = "createName";
                    } else if (val.length == 2) {
                        this.showListitem = "gridName";
                        this.searchlist.communityId = val[1];
                        this.searchlist.gridId = "";
                    }
                } else {
                    this.searchlist.communityId = "";
                    this.searchlist.gridId = "";
                    this.showListitem = "communityName";
                }
            }

            this.getpageList();
        },
        timeChange(val) {
            if (val) {
                this.searchlist.liveStartTime = val[0];
                this.searchlist.liveEndTime = val[1];
            } else {
                this.searchlist.liveStartTime = "";
                this.searchlist.liveEndTime = "";
            }
        },
        async showDialog(row, flag) {
            this.flag = flag;

            if (row) {
                this.editDialog.fatherid = row.id || "";
                this.editDialog.fatherdata = JSON.parse(JSON.stringify(row));
            } else {
                this.editDialog = {
                    show: "",
                    readonly: false,
                    fatherdata: null,
                    fatherid: null
                };
            }

            switch (flag) {
                case "update":
                    this.editDialog.readonly = false;
                    this.editDialog.show = "add";

                    break;

                case "add":
                    this.editDialog.readonly = false;
                    this.editDialog.show = "add";

                    break;
                case "look":
                    this.editDialog.readonly = true;
                    this.editDialog.show = "add";

                    break;

                case "delete":
                    this.$confirm("此操作将删除该活动, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }).then(async () => {
                        let deleteRes = await gridLogApi.delete({
                            id: row.id
                        });
                        console.log(deleteRes);

                        if (deleteRes.code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功"
                            });
                            this.getPageDatas();
                            return;
                        }
                    });
                    break;
            }
        },
        dialogReback(val) {
            if (val.dialog == "success") {
                this.showListitem = "communityName";
                this.searchlistReset();
                this.searchlistdata2()
            }
            this.editDialog = {
                show: "",
                readonly: false,
                fatherdata: null,
                fatherid: null
            };
        },

        // 超过3级,不能选中,子级分类最多4级
        /**
         * count: 当前层级
         * data: 当前层级的数据
         * maxNum: 最多不能超过几级
         */
        setDisable(count, data, maxNum) {
            if (count > maxNum) {
                //最多几级就写几
                data.forEach(v => {
                    v.disabled = true; // 超过设定的最大级数,给这一集的数据添加disabled属性
                });
            } else {
                data.forEach(v => {
                    v.count = count; // 设置最外层数据的初始count

                    if (v.childs && v.childs.length) {
                        v.count++;
                        this.setDisable(v.count, v.childs, maxNum); // 子级循环时把这一层数据的count传入
                    }
                });
            }
        },
        async getpageList() {
            //   if (this.$store.state.info.orgLevel == 4) {
            //     this.showListitem = "detail";
            //     this.initTableDataUrl(gridLogApi.getTableDataUrl);
            //     return;
            //   }
            //   if (this.$store.state.info.orgLevel == 4) {
            //     this.showListitem = "detail";
            //     this.initTableDataUrl(gridLogApi.getTableDataUrl);
            //     return;
            //   }
            this.pageList = [];
            let result = null;
            if (this.showListitem == "detail") {
                this.initTableDataUrl(gridLogApi.getTableDataUrl);
                return;
            }

            if (this.showListitem == "createName") {
                result = await gridLogApi.getTableData_user({
                    communityId: this.searchlist.communityId,
                    gridId: this.searchlist.gridId
                });
                // this.initTableDataUrl(gridLogApi.getTableDataUrl);
            } else if (this.showListitem == "gridName") {
                result = await gridLogApi.getTableData_grid({
                    communityId: this.searchlist.communityId
                });
            } else if (this.showListitem == "communityName") {
                result = await gridLogApi.getTableData_community();
                //  result = await gridLogApi.getTableData_community({
                //     pageNo: 1,
                //     pageSize: 10
                // });
            }

            if (result.content) {
                this.pageList = result.content;
                // this.pageList = result.content.list;
            }
        }
    },
    mounted() {
        this.searchlistReset2();
        this.getpageList();
        this.OrgTreelist();
        this.searchlistdata2();
    },
    created() {}
};
</script>

<style lang="less" >
.listBox {
    width: 100%;
}
.page-list-box {
    text-align: center;
    .el-card {
        border: none;
    }
    img {
        width: 100%;
        display: block;
        margin: 20px auto 10px;
        max-width: 100px;
    }
    .page-list-item.person {
        .title {
            font-size: 20px;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 10px;
        }
        .main {
            height: 100px;
            overflow: hidden auto;
            word-break: break-all;
            text-align: -webkit-auto;
        }
        .bottom {
            text-align: right;
            padding: 14px;
            line-height: 25px;
        }
    }
}
</style>
 